<template>
  <page>
    <div class="filters" v-loading="loading.dashboard">
      <el-form inline size="small">
        <el-form-item>
          <el-date-picker
            v-model="datesRange"
            type="daterange"
            unlink-panels
            clearable
            start-placeholder="Start date"
            end-placeholder="End date"
            :format="dateRangeFormat"
            :picker-options="datePickerOptions"
          />
        </el-form-item>
      </el-form>
    </div>

    <card title="Sales" v-loading="loading.sales" style="max-width: 100%">
      <Table
        :items="cleanedResults"
        :columns="columns"
        :actions="actions"
        :links="links"
      />
      <div class="pagination">
        <el-pagination
          layout="prev, pager, next"
          :page-size="20"
          :current-page="sales.page + 1"
          :total="sales.total"
          @current-change="fetchData"
        />
      </div>
    </card>
    <SalesDialog
      :item="item"
      :isOpen="showEditDialog"
      :onClose="() => (showEditDialog = false)"
      @saved="fetchData"
    />
  </page>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";

import Page from "@/components/layout/Page";
import Card from "@/components/Card";
import Table from "@/components/Table";
import { datePickerOptions } from "./constants";
import SalesDialog from "./SalesDialog";

export default {
  data() {
    return {
      datesRange: [],
      columns: [
        { prop: "email", label: "Email" },
        { prop: "slug", label: "Team slug" },
        { prop: "annual_deal_size", label: "Plan price" },
        { prop: "sale_date", label: "Start date" },
        { prop: "renewal_date", label: "Renewal date" },
        { prop: "seats_count", label: "Seats" },
        { prop: "projects_limit_count", label: "Projects" },
        { prop: "screens_limit_count", label: "Screens" },
        { prop: "owner_notes", label: "Owner notes" },
      ],
      item: { owner: {} },
      showEditDialog: false,
      actions: [
        {
          name: "Edit notes",
          onClick: (item) => {
            this.item = item;
            this.showEditDialog = true;
          },
        },
      ],
      links: [
        {
          label: "View team",
          to: (item) => `/customers/team/${item._id}`,
        },
      ],
      datePickerOptions,
      dateRangeType: "date",
      dateRangeFormat: "d MMM, yyyy",
    };
  },
  components: {
    Page,
    Card,
    Table,
    SalesDialog,
  },
  async mounted() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters(["sales", "loading"]),
    cleanedResults() {
      return this.sales.results.map((sale) => ({
        ...sale,
        sale_date: sale.sale_date
          ? moment(sale.sale_date).format(this.dateRangeFormat)
          : "",
        renewal_date: sale.sale_date
          ? moment(sale.sale_date).add(1, "Y").format(this.dateRangeFormat)
          : "",
        projects_limit_count:
          sale.projects_limit_count === -1
            ? "Unlimited"
            : sale.projects_limit_count,
      }));
    },
  },
  methods: {
    ...mapActions(["getSales"]),
    ...mapMutations(["unsetLoading"]),
    async fetchData(currentPage = 0, start, end) {
      await this.getSales({ page: Math.max(currentPage - 1, 0), start, end });
      this.unsetLoading("sales");
    },
  },
  watch: {
    datesRange: {
      deep: true,
      handler() {
        const { datesRange } = this;
        if (datesRange) {
          const [start, end] = datesRange;
          this.fetchData(1, start, end);
        } else {
          this.fetchData();
        }
      },
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.filters {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

@media screen and (max-width: 600px) {
  .filters {
    flex-direction: column;
    max-width: 100%;
  }
}
</style>
